import styled, { css } from "styled-components";
import {
  GRAY_LIGHT,
  TEXT_SECONDARY,
  WHITE
} from "@streeteasy/design-system/colors";
import Button from "@streeteasy/design-system/deprecated/actions/button";
import { Body } from "@streeteasy/design-system/typography";
import { SwiperSlide } from "swiper/react/swiper-react";

import { smallScreen } from "src/shared/constants/screenSizes";

const baseNavigationArrow = css`
  color: ${TEXT_SECONDARY};
  font: 22px/25px FontAwesome;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`;

export const Container = styled.section`
  margin: 0 auto;
  max-width: 1404px;
  padding: 32px 48px;
  position: relative;

  &:before {
    background: ${GRAY_LIGHT};
    content: "";
    height: 1px;
    left: 48px;
    position: absolute;
    top: 0;
    width: calc(100% - 96px);
  }

  @media screen and (max-width: ${smallScreen}px) {
    padding-left: 24px;
    padding-right: 24px;

    &:before {
      left: 24px;
      width: calc(100% - 48px);
    }
  }
`;

export const DesktopListingsContainer = styled.div`
  display: block;
  position: relative;

  @media screen and (max-width: ${smallScreen}px) {
    display: none;
  }

  .swiper-slide {
    height: auto;
    margin-right: 26px;
    width: calc(50% - 26px / 2);

    @media screen and (min-width: 1060px) {
      width: calc(100% / 3 - 52px / 3);
    }

    @media screen and (min-width: 1430px) {
      width: calc(25% - 78px / 4);
    }
  }
`;

export const ListingSlide = styled(SwiperSlide)`
  width: calc(50% - 26px / 2);

  @media screen and (min-width: 1060px) {
    width: calc(100% / 3 - 52px / 3);
  }

  @media screen and (min-width: 1430px) {
    width: calc(25% - 78px / 4);
  }
`;

export const MobileListingCardContainer = styled.div`
  margin-bottom: 15px;
`;

export const MobileListingsContainer = styled.div`
  display: none;

  @media screen and (max-width: ${smallScreen}px) {
    display: block;
  }
`;

const NavigationButton = styled.button`
  background: ${WHITE};
  border: none;
  border-radius: 50%;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.137228);
  font-size: 0;
  height: 52px;
  position: absolute;
  top: calc(50% - 26px);
  width: 52px;
  z-index: 1;

  &[disabled] {
    display: none;
  }

  &:before {
    ${baseNavigationArrow}
  }

  @media screen and (max-width: 1484px) {
    top: -92px;
  }
`;

export const NextButton = styled(NavigationButton)`
  right: -78px;

  &:before {
    content: "\f105";
    right: 21px;
  }

  @media screen and (max-width: 1484px) {
    right: 0;
  }
`;

export const PreviousButton = styled(NavigationButton)`
  left: -78px;

  &:before {
    content: "\f104";
    left: 21px;
  }

  @media screen and (max-width: 1484px) {
    left: unset;
    right: 72px;
  }
`;

export const SectionSubheading = styled(Body)`
  color: ${TEXT_SECONDARY};
  font-weight: normal;
  margin: 8px 0 32px;
`;

export const ViewMoreButton = styled(Button)`
  display: block;
  margin: 0 auto;
`;
